var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "actions-wrapper",
      attrs: { "data-test": "message-actions" }
    },
    [
      _c(
        "v-menu",
        {
          attrs: {
            "offset-y": "",
            left: "",
            "nudge-bottom": 4,
            "content-class": "chat-actions-menu"
          },
          on: { input: _vm.onMenuToggle },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass: "action-trigger",
                          style: { backgroundColor: _vm.bubbleColor },
                          attrs: {
                            icon: "",
                            "x-small": "",
                            "data-test": "action-trigger"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                            }
                          }
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "mdi-chevron-down",
                          size: "16",
                          color: "#8E8E8E"
                        }
                      })
                    ],
                    1
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.showMenu,
            callback: function($$v) {
              _vm.showMenu = $$v
            },
            expression: "showMenu"
          }
        },
        [
          _c(
            "div",
            {
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _vm.canReact
                ? _c(
                    "div",
                    { staticClass: "emoji-bar d-flex align-center px-2 py-1" },
                    _vm._l(_vm.quickEmojis, function(emoji) {
                      return _c(
                        "v-btn",
                        {
                          key: emoji,
                          staticClass: "emoji-btn",
                          attrs: { icon: "", small: "" },
                          on: {
                            click: function($event) {
                              return _vm.onSelectEmoji(emoji)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(emoji) + " ")]
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _vm.canReact && _vm.menuItems.length > 0
                ? _c("v-divider")
                : _vm._e(),
              _c(
                "v-list",
                {
                  staticClass: "az-list-no-icon-spacing py-1",
                  attrs: { dense: "" }
                },
                [
                  _vm._l(_vm.menuItems, function(item) {
                    return _c(
                      "v-list-item",
                      {
                        key: item.key,
                        attrs: { "data-test": "action-" + item.key },
                        on: {
                          click: function($event) {
                            return _vm.onMenuItemClick(item)
                          }
                        }
                      },
                      [
                        _c(
                          "v-list-item-icon",
                          [
                            _c("icon-svg", {
                              attrs: {
                                name: item.icon,
                                size: "16",
                                color: "#8E8E8E"
                              }
                            })
                          ],
                          1
                        ),
                        _c("v-list-item-title", [
                          _vm._v(" " + _vm._s(item.label) + " ")
                        ])
                      ],
                      1
                    )
                  }),
                  _vm.canSendToDrive
                    ? _c(
                        "v-menu",
                        {
                          attrs: {
                            value: _vm.driveMenuOpen,
                            "offset-x": "",
                            right: "",
                            "nudge-right": "4",
                            "content-class": "chat-actions-menu"
                          },
                          on: { input: _vm.onDriveMenuInput },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-list-item",
                                      _vm._b(
                                        {
                                          attrs: {
                                            "data-test": "action-drive"
                                          },
                                          on: {
                                            mouseenter: _vm.openDriveMenu,
                                            mouseleave: _vm.scheduleDriveClose
                                          }
                                        },
                                        "v-list-item",
                                        attrs,
                                        false
                                      ),
                                      [
                                        _c(
                                          "v-list-item-icon",
                                          [
                                            _c("icon-svg", {
                                              attrs: {
                                                name: _vm.driveIcon,
                                                size: "16",
                                                color: "#8E8E8E"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c("v-list-item-title", [
                                          _vm._v(_vm._s(_vm.sendToDriveLabel))
                                        ]),
                                        _c("icon-svg", {
                                          attrs: {
                                            name: "mdi-chevron-right",
                                            size: "16",
                                            color: "#8E8E8E"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4220489769
                          )
                        },
                        [
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                },
                                mouseenter: _vm.cancelDriveClose,
                                mouseleave: _vm.scheduleDriveClose
                              }
                            },
                            [
                              _c(
                                "v-list",
                                {
                                  staticClass: "az-list-no-icon-spacing py-1",
                                  attrs: { dense: "" }
                                },
                                [
                                  _c(
                                    "v-list-item",
                                    {
                                      attrs: {
                                        "data-test": "action-drive-root",
                                        disabled: !_vm.driveTreeLoaded
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.onPickDriveFolder(
                                            _vm.driveRootNode
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("AAWZ Drive (raiz)")
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm.driveRootFolders.length
                                    ? _c("v-divider")
                                    : _vm._e(),
                                  _c("AawzDriveFolderPickerMenu", {
                                    attrs: { folders: _vm.driveRootFolders },
                                    on: {
                                      select: _vm.onPickDriveFolder,
                                      active: _vm.cancelDriveClose
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.canSendToDrive
                    ? _c(
                        "v-menu",
                        {
                          attrs: {
                            value: _vm.driveRenameMenuOpen,
                            "offset-x": "",
                            right: "",
                            "nudge-right": "4",
                            "content-class": "chat-actions-menu"
                          },
                          on: { input: _vm.onDriveRenameMenuInput },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-list-item",
                                      _vm._b(
                                        {
                                          attrs: {
                                            "data-test": "action-drive-rename"
                                          },
                                          on: {
                                            mouseenter: _vm.openDriveRenameMenu,
                                            mouseleave:
                                              _vm.scheduleDriveRenameClose
                                          }
                                        },
                                        "v-list-item",
                                        attrs,
                                        false
                                      ),
                                      [
                                        _c(
                                          "v-list-item-icon",
                                          [
                                            _c("icon-svg", {
                                              attrs: {
                                                name: _vm.driveIcon,
                                                size: "16",
                                                color: "#8E8E8E"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c("v-list-item-title", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.sendToDriveRenameLabel
                                              ) +
                                              " "
                                          )
                                        ]),
                                        _c("icon-svg", {
                                          attrs: {
                                            name: "mdi-chevron-right",
                                            size: "16",
                                            color: "#8E8E8E"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3756653252
                          )
                        },
                        [
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                },
                                mouseenter: _vm.cancelDriveRenameClose,
                                mouseleave: _vm.scheduleDriveRenameClose
                              }
                            },
                            [
                              _c(
                                "v-list",
                                {
                                  staticClass: "az-list-no-icon-spacing py-1",
                                  attrs: { dense: "" }
                                },
                                [
                                  _c(
                                    "v-list-item",
                                    {
                                      attrs: {
                                        "data-test": "action-drive-rename-root",
                                        disabled: !_vm.driveTreeLoaded
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.onPickDriveFolderRename(
                                            _vm.driveRootNode
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("AAWZ Drive (raiz)")
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm.driveRootFolders.length
                                    ? _c("v-divider")
                                    : _vm._e(),
                                  _c("AawzDriveFolderPickerMenu", {
                                    attrs: { folders: _vm.driveRootFolders },
                                    on: {
                                      select: _vm.onPickDriveFolderRename,
                                      active: _vm.cancelDriveRenameClose
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.canDelete
                    ? _c(
                        "v-list-item",
                        {
                          attrs: { "data-test": "action-delete" },
                          on: {
                            click: function($event) {
                              return _vm.onMenuItemClick({
                                action: _vm.onDelete
                              })
                            }
                          }
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("icon-svg", {
                                attrs: {
                                  name: _vm.icons.delete,
                                  size: "16",
                                  color: "#8E8E8E"
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-list-item-title", [_vm._v("Remover nota")])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }